import React from 'react';
import { CheckCircle } from 'lucide-react';
import { mockData } from '../data/mock';
import { HeroStats, HeroCTA, HeroTrustPoints } from './hero/HeroParts';
import { HeroVisual } from './hero/HeroVisual';

const Hero = () => (
  <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
    <div className="absolute inset-0 z-0">
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-50 via-white to-teal-50"></div>
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10">
        <img src={mockData.hero.image} alt="Business consultation" className="w-full h-full object-cover" />
      </div>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div className="space-y-8">
          <div className="inline-flex items-center px-4 py-2 bg-cyan-100 text-cyan-700 rounded-full text-sm font-medium">
            <CheckCircle className="w-4 h-4 mr-2" />
            40+ Years in Banking &amp; 100 Years Cumulative Expertise
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            {mockData.hero.title}
          </h1>

          <p className="text-xl text-gray-600 leading-relaxed">
            {mockData.hero.subtitle}
          </p>

          <HeroStats stats={mockData.stats.slice(0, 2)} />
          <HeroCTA />
          <HeroTrustPoints />
        </div>

        <HeroVisual image={mockData.hero.image} />
      </div>
    </div>

    <div className="absolute top-20 left-10 w-20 h-20 bg-yellow-400 rounded-full opacity-20 blur-3xl"></div>
    <div className="absolute bottom-20 right-20 w-32 h-32 bg-cyan-400 rounded-full opacity-20 blur-3xl"></div>
  </section>
);

export default Hero;
